import { c as _c } from "react/compiler-runtime";
import { Divider, Stack, Typography } from '@mui/material';
import type { Provider, ResourceType } from '@repo/api-gw-sdk';
import { useState } from 'react';
import { useDebouncedValue } from '@/utils/useDebouncedValue';
import { ResourcesSelectorAccordion } from './resourcesSelector';
import { useResourceIdentifiers } from '../queryBuilder/useResourceIentifiers';
export const ResourceSelectionManualOverridesEditor = t0 => {
  const $ = _c(42);
  const {
    description,
    includeResources,
    excludeResources,
    setIncludedResources,
    setExcludedResources,
    supportedProviders,
    supportedResourceTypes
  } = t0;
  const [includeFilter, setIncludeFilter] = useState("");
  const [excludeFilter, setExcludeFilter] = useState("");
  const debouncedIncludeFilter = useDebouncedValue(includeFilter, 300);
  const debouncedExcludeFilter = useDebouncedValue(excludeFilter, 300);
  const {
    data: allResourcesData
  } = useResourceIdentifiers(supportedProviders, supportedResourceTypes);
  const {
    data: includeResourcesData
  } = useResourceIdentifiers(supportedProviders, supportedResourceTypes, debouncedIncludeFilter || undefined);
  const {
    data: excludeResourcesData
  } = useResourceIdentifiers(supportedProviders, supportedResourceTypes, debouncedExcludeFilter || undefined);
  let t1;
  if ($[0] !== allResourcesData?.resources) {
    t1 = allResourcesData?.resources ?? [];
    $[0] = allResourcesData?.resources;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const allResources = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: "32px",
      width: "308px"
    };
    t3 = <Typography variant="h3">Manual overrides</Typography>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      gap: "24px",
      overflow: "auto"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== description) {
    t5 = <Typography variant="body1">{description}</Typography>;
    $[5] = description;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      gap: "12px"
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = `${includeResources.length} resources manually included${includeResources.length ? ":" : "."}`;
  let t8;
  if ($[8] !== includeResourcesData?.resources) {
    t8 = includeResourcesData?.resources ?? [];
    $[8] = includeResourcesData?.resources;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t10;
  let t9;
  if ($[10] !== includeResources || $[11] !== setIncludedResources) {
    t9 = resource => setIncludedResources([...includeResources, resource]);
    t10 = resource_0 => setIncludedResources(includeResources.filter(r => r !== resource_0));
    $[10] = includeResources;
    $[11] = setIncludedResources;
    $[12] = t10;
    $[13] = t9;
  } else {
    t10 = $[12];
    t9 = $[13];
  }
  let t11;
  if ($[14] !== allResources || $[15] !== includeResources || $[16] !== t10 || $[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
    t11 = <ResourcesSelectorAccordion label="Included resources" description={t7} allResources={allResources} filteredResources={t8} resources={includeResources} onFilterChange={setIncludeFilter} addResource={t9} removeResource={t10} />;
    $[14] = allResources;
    $[15] = includeResources;
    $[16] = t10;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Divider />;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const t13 = `${excludeResources.length} resources manually excluded:`;
  let t14;
  if ($[22] !== excludeResourcesData?.resources) {
    t14 = excludeResourcesData?.resources ?? [];
    $[22] = excludeResourcesData?.resources;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  let t16;
  if ($[24] !== excludeResources || $[25] !== setExcludedResources) {
    t15 = resource_1 => setExcludedResources([...excludeResources, resource_1]);
    t16 = resource_2 => setExcludedResources(excludeResources.filter(r_0 => r_0 !== resource_2));
    $[24] = excludeResources;
    $[25] = setExcludedResources;
    $[26] = t15;
    $[27] = t16;
  } else {
    t15 = $[26];
    t16 = $[27];
  }
  let t17;
  if ($[28] !== allResources || $[29] !== excludeResources || $[30] !== t13 || $[31] !== t14 || $[32] !== t15 || $[33] !== t16) {
    t17 = <ResourcesSelectorAccordion label="Excluded resources" description={t13} allResources={allResources} filteredResources={t14} resources={excludeResources} onFilterChange={setExcludeFilter} addResource={t15} removeResource={t16} />;
    $[28] = allResources;
    $[29] = excludeResources;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Divider />;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t11 || $[37] !== t17) {
    t19 = <Stack sx={t6}>{t11}{t12}{t17}{t18}</Stack>;
    $[36] = t11;
    $[37] = t17;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t19 || $[40] !== t5) {
    t20 = <Stack sx={t2}>{t3}<Stack sx={t4}>{t5}{t19}</Stack></Stack>;
    $[39] = t19;
    $[40] = t5;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  return t20;
};